<template>
  <Dropdown style="margin-right: 16px" @on-click="handleSwitch">
    <Button type="primary">
      {{ currentMeta[lang] }}
      <Icon type="arrow-down-b"></Icon>
    </Button>
    <Dropdown-menu slot="list">
      <Dropdown-item
        v-for="(item,ix) in sysList"
        :key="item.path"
        :name="ix"
        :disabled="item.meta.title==currentMeta.title"
        v-show="item.meta[lang]"
        >{{ item.meta[lang] }}</Dropdown-item>
    </Dropdown-menu>
  </Dropdown>
</template>
<script>
import { visionRouteList } from '@/router/routers.js';
import langMap from '@/utils/language';
import { mapState } from 'vuex';
import { findRouteByName } from '@/libs/util.js';
// iveiw (vue2) https://iview.github.io/components/dropdown
const manageSys = { path: '/', meta: { title: '管理系统',...langMap.sys1 } };

function updateLng(sys, menus, lang) { 
  sys.forEach(item => {
    const _routeItem = findRouteByName(menus, item.name);
    if (_routeItem) { item.meta[lang] = _routeItem.title; }
  })
}

export default {
  data() {
    return {
      currentMeta: {title:'',zh:'',en:''},
      sysList: []
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
      sysMenulist: state => state.app.sysMenulist
    }),
  },
  watch: {
    // 同步语言变化
    sysMenulist(nvals) {

      updateLng(visionRouteList, nvals, this.lang);
      this.sysList = [manageSys, ...visionRouteList];
      
      const _item = this.sysList.find(item => item.meta.title === this.currentMeta.title);
      if (_item) {
        this.currentMeta[this.lang] = _item.meta[this.lang];
      }
    }
  },
  methods: {
    handleSwitch(ix) {
      let item = this.sysList[ix];

      if (item.meta.title === this.currentMeta.title) return;

      this.currentMeta = item.meta;
      // 有子路由的情况
      let childPath = item.children? '/'+item.children[0].path : '';

      this.$router.push({ path: item.path + childPath });

      this.$emit('change', item.path + childPath);
      // 新窗口切到管理系统再切回来的bug修复
      window.opener = null;
    }
  },
  created() {
    // 全局加载 leaflet 地图配置，确保每次刷新都会加载
    this.$store.dispatch('loadLeafletConfig').catch(err => {
      console.error('全局加载leaflet配置失败:', err);
    });
    const currentRoute = this.$route;
    // 更新语言
    updateLng(visionRouteList, this.sysMenulist, this.lang);

    this.sysList = [manageSys, ...visionRouteList];
    console.log(this.sysList)

    const res = this.sysList.some(route => {
      const reg = new RegExp(`^${route.path}`);
      // 系统管理情况直接返回
      if (route.path === '/') return false;
      if (reg.test(currentRoute.path)) {
        this.currentMeta = route.meta;
        return true;
      }
    });
    // 未找到匹配项时则默认管理系统
    if(!res) this.currentMeta = manageSys.meta;
  }
}
</script>
